import MicroModal from 'micromodal';  // es6 module
import jQuery from "jquery"; window.$ = window.jQuery = jQuery;

MicroModal.init({
	awaitCloseAnimation: true,
	//disableScroll: true
});


// navigation

var navOpen = false;

$(".nav-trigger-wrapper, .dark-overlay").on("click", function(){
	$("body").toggleClass("nav-open");
});

function navParents(evt) {
	var target = $(evt.target);
	if (!target.parents('header').length) {
		if($("body").hasClass("search-open")){
			$("body").removeClass("search-open");
			$(document).off('click', navParents);
		}
	}
}

// slider

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

if($('.swiper-container').length){

	document.querySelectorAll('.swiper-container').forEach(function(elem) {

		const slidesPerView = elem.getAttribute("data-slides-per-view");

		var mySwiper = new Swiper(elem, {
			slidesPerView: 1,
			simulateTouch: false,
			navigation: {
				nextEl: elem.nextElementSibling.nextElementSibling,
				prevEl: elem.nextElementSibling,
			},
			breakpoints: {
				// when window width is <= 767px
				767: {
					slidesPerView: slidesPerView,
					spaceBetween: 8
				}
			}
		});

	});
}

if($('.project-single-swiper-container').length) {

	var stlSingleSlider = new Swiper('.project-single-swiper-container', {
		simulateTouch: false,
		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

}



//Swiper - Home
const swiper = new Swiper(".parallax-teaser", {
	slidesPerView: 1,
	spaceBetween: 500,
	centeredSlides: true,
	simulateTouch: false,
	preloadImages: false,
	lazy: {
		loadPrevNext: true,
		loadPrevNextAmount: 10,
	},
	speed: 750,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
	},
	breakpoints: {
		// when window width is <= 1220px
		1220: {
			spaceBetween: 50
		}
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});

swiper.on('slideNextTransitionStart', function (event,element) {
	console.log(event);
	console.log(element);
});

import Accordion from 'accordion-js';

document.querySelectorAll('.accordion-container').forEach((element) => {

	let showMultiple = element.getAttribute('data-show-multiple') !== 'false';
	let openOnInit = [];

	if(!showMultiple){
		openOnInit = [0];
	}

	new Accordion(element, {
		duration: 200,
		showMultiple: showMultiple,
		openOnInit: openOnInit
	});
});


const mapElement = document.getElementById('map');
if(mapElement){
	let map = new Map( latLng['lat'], latLng['lng']);
	map.init();
}

// filter
const $shopFilter = $(".shop-grid__filter");

if($shopFilter.length){

	const $shopGridContainer = $(".shop-grid__container > .row");
	const $filterLinks = $shopFilter.find("li");
	const activeClass = 'is--active';
	const $removeFilterButton = $('.shop-grid__filter__remove-all');

	$filterLinks.on("click", function(){
		const $this = $(this);
		let filterSlug = [];
		const data = {
			'action': 'flair_load_shops'
		};
		const category = $this.attr('data-category');


		if($this.hasClass(activeClass)){
			$this.removeClass(activeClass);
		} else if($this.hasClass('shop-grid__filter__remove-all')) {
			$filterLinks.removeClass(activeClass);
		} else {
			$this.addClass(activeClass);
		}

		$(".shop-grid__filter li.is--active").each(function(){
			filterSlug.push($(this).attr("data-filter"))
		});

		if(filterSlug.length !== 0){
			data.filter = filterSlug;
			$removeFilterButton.removeClass(activeClass);
		} else {
			$removeFilterButton.addClass(activeClass);
		}

		if (typeof category !== 'undefined' && category !== false) {
			data.category = category;
		}

		$.ajax({
			url : ajaxUrl,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$this.on('click', function(e){
				 	e.preventDefault();
				 	e.stopPropagation();
				});
			},
			success : function( data ){
				$shopGridContainer.html(data);
			}
		});
	});

}




// floormap

const $shopMaps = $(".shop-maps");

if($shopMaps.length){

	const $floorNavigation = $(".shop-maps__floor-navigation");
	const $floorNavigationLinks = $floorNavigation.find('a');
	const $shopMap = $(".shop-maps__item");
	const activeClass = 'is--active';

	$floorNavigationLinks.on('click', function(e){
		e.preventDefault();
		const $this = $(this);
		const floorIndex = $this.index() - 1;

		$floorNavigationLinks.removeClass(activeClass);
		$this.addClass(activeClass);

		$shopMap
			.removeClass(activeClass)
			.eq(floorIndex)
			.addClass(activeClass);
	});

	$("body").on('mouseenter','.map-trigger__item', function(){
		classHandleMap($(this),'add');
	}).on('mouseleave','.map-trigger__item', function(){
		classHandleMap($(this),'remove');
	});

	const $mouseTrigger = '.shop-maps__item .stores g, .shop-maps__item .stores rect, .shop-maps__item .stores polygon';

	const trigger = document.querySelectorAll($mouseTrigger);

	trigger.forEach(function(elem){
		elem.addEventListener('mouseenter', function(){
			console.log(elem);
		});
	});

	$("body").on('mouseenter',$mouseTrigger, function(){
		classHandleText($(this),'add');
	}).on('mouseleave',$mouseTrigger, function(){
		classHandleText($(this),'remove');
	});

	function classHandleMap($this, action){

		const shop_id = $this.find('.map-trigger__item__nr').html();
		const $target = $('*[data-name="store '+shop_id+'"]');

		if(action === 'add'){
			$target.each(function(){
				$(this).addClass(activeClass);
			})
		} else {
			$target.each(function(){
				$(this).removeClass(activeClass);
			})
		}

	}

	function classHandleText($this, action){
		const targetId = $this.attr('id');
		const $target = $(".map-trigger__item__" + targetId);

		if(action === 'add'){
			$target.addClass('is--active');
			if($target.length){
				$this
					.addClass('is--active')
					.one('click', function(){
						window.location.href = $target.attr('href');
					});
			}
		} else {
			$target.add($this).removeClass('is--active');
		}
	}

}

// search
const $headerSearch = $(".header__search");
$(".header__search__trigger").on("click", function(){
	if($headerSearch.hasClass('is--active') && $headerSearch.find("form input").val() !== ''){
		$headerSearch.find("form").submit();
	}
	$headerSearch.addClass('is--active');
	setTimeout(function(){
		$(".header__search input").focus();
	}, 200);
});


document.addEventListener('DOMContentLoaded', function() {
	const $navTrigger = document.querySelector('.nav-trigger-wrapper');
	const $headerBar = document.querySelector(".header__search");

	$navTrigger.addEventListener("click", clickHandler);

	function clickHandler() {
		if($headerBar.classList.contains('is--active')){
			$headerBar.classList.remove('is--active');
		}
	}
});

// parallax scrolling
(function () {

	const backgroundHeart = document.querySelectorAll('.background-heart');

	if(!backgroundHeart || window.innerWidth < 991) return;

	let initialOffset = [];

	backgroundHeart.forEach((element) => {
		initialOffset.push(offset(element).top);
	});

	window.onscroll = function () {
		window.requestAnimationFrame(scrollRotate);
	};

	let inited = false;

	function isOdd(num) { return num % 2;}

	function scrollRotate() {

		backgroundHeart.forEach((element, index) => {

			const transformSpeed = element.getAttribute('data-transform');
			const rotationSpeed = element.getAttribute('data-rotate');
			const rotationStart = parseInt(element.getAttribute('data-rotation-start'));
			const rotationDirection = element.getAttribute('data-rotation-direction');

			const direction = (rotationDirection === 'r') ? 1 : -1 ;
			const rotation = (window.pageYOffset + window.innerHeight - initialOffset[index]) * direction;
			const movement = (window.pageYOffset + window.innerHeight - initialOffset[index]) * -1 * transformSpeed;

			const rotationCalc = parseFloat(rotationStart + (rotation / 50 * rotationSpeed));

			if(window.pageYOffset + window.innerHeight - initialOffset[index] < 0){
				return;
			}

			element.style.transform = "rotate("+ rotationCalc +"deg) translate3d("+rotation/20+"px,"+ movement / 4 +"px,0)";

		});

		if(!inited){
			$(".background-heart").css('visibility', 'visible');
			inited = true;
		}

	}

	function offset(el) {
		var rect = el.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
	}

	scrollRotate();

}());



var $window = $(window);
var wScroll = $window.scrollTop();
var $fadeBox = $('.fade-box');


$window.scroll(function() {

	wScroll = $(this).scrollTop();

	$fadeBox.each(function(){

		var $this = $(this);

		if(wScroll > $this.offset().top - ($window.height() / 1.2)) {

			$this.find('.fade-elem').each(function(i){
				var $_this = $(this);

				setTimeout(function(){
					$_this.addClass('fade');
				}, 300 * (i+1));

			});
		}

	});

});

function checkFadeIn(){

	$fadeBox.each(function(){

		var $this = $(this);

		if(wScroll > $this.offset().top - ($window.height() / 1.2)) {

			$this.find('.fade-elem').each(function(i){
				var $_this = $(this);

				setTimeout(function(){
					$_this.addClass('fade');
				}, 150 * (i+1));

			});

		}
	});

}

checkFadeIn();

// wrap buttons
$( ".button" ).wrapInner( "<span></span>");

$(".mobile-filter__trigger").on("click", function(){
	$(".shop-grid__filter__wrapper").toggleClass("is--open");
});

